// src/App.js
import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './components/User/Home';
import AdminLogin from './components/Admin/AdminLogin';
import Dashboard from './components/Admin/Dashboard';
import Categories from './components/User/Categories'; // ✅ Import the CollegePage component
import Teams from './components/User/Teams'; // ✅ Import the Teams component
import EditorialStaff from './components/User/EditorialStaff'; // ✅ Import the new component
import Announcements from "./components/User/Announcements";




function App() {
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    setIsAdmin(!!token);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    setIsAdmin(false);
  };

  return (
    <Router>
      <Layout isAdmin={isAdmin} onLogout={handleLogout}>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/categories" element={<Categories />} /> {/* ✅ Add route for Categories */}
          <Route path="/teams" element={<Teams />} /> {/* ✅ Add route for Teams */}
          <Route path="/editorial-staff" element={<EditorialStaff />} /> {/* ✅ Add the new route */}
          <Route path="/announcements" element={<Announcements />} />
          
         
          


          {/* Admin Routes */}
          <Route
            path="/admin" 
            element={isAdmin ? <Dashboard /> : <AdminLogin />}
          />

          {/* Redirect */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Layout>
    </Router>

    
  );
}

export default App;